import { useState } from "react"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import { toast } from "react-toastify"

import { downloadDailyReportPdf } from "api/dailyReportApi"

const titleCase = key =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase())

const renderValue = value => {
  if (value === null || value === undefined || value === "") return "—"
  if (typeof value === "boolean") return value ? "Yes" : "No"

  if (Array.isArray(value)) {
    if (value.length === 0) return "—"
    const hasObjects = value.some(v => v && typeof v === "object")
    if (!hasObjects) return value.join(", ")

    const cols = Object.keys(value[0] || {})
    return (
      <Table size="sm" bordered responsive className="mb-0">
        <thead>
          <tr>
            {cols.map(c => (
              <th key={c}>{titleCase(c)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {value.map((row, i) => (
            <tr key={i}>
              {cols.map(c => (
                <td key={c}>{renderValue(row?.[c])}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }

  if (typeof value === "object") {
    return (
      <Table size="sm" borderless className="mb-0">
        <tbody>
          {Object.entries(value).map(([k, v]) => (
            <tr key={k}>
              <td className="text-muted">{titleCase(k)}</td>
              <td>{renderValue(v)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    )
  }
  return String(value)
}

const ReportViewModal = ({ isOpen, toggle, report }) => {
  const [downloading, setDownloading] = useState(false)
  const payload = report?.payload ?? {}
  const sections = Object.entries(payload).filter(([key]) => key !== "meta")

  const handlePdf = async () => {
    setDownloading(true)
    try {
      const blob = await downloadDailyReportPdf(report.id)
      window.open(URL.createObjectURL(blob), "_blank", "noopener")
    } catch (err) {
      toast.error(err?.response?.data?.message || "Could not open PDF")
    } finally {
      setDownloading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
      <ModalHeader toggle={toggle}>
        {report?.period === "monthly" ? "Monthly" : "Daily"} Report —{" "}
        {report?.report_date}
      </ModalHeader>
      <ModalBody>
        {sections.length === 0 && <p className="text-muted">No data captured.</p>}
        {sections.map(([key, value]) => (
          <div key={key} className="mb-3">
            <h6 className="fw-bold border-bottom pb-1">{titleCase(key)}</h6>
            {value && typeof value === "object" && value.error ? (
              <span className="text-muted">{value.error}</span>
            ) : (
              renderValue(value)
            )}
          </div>
        ))}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handlePdf} disabled={downloading}>
          <i className="mdi mdi-file-pdf-box" /> Open PDF
        </Button>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default ReportViewModal
